export default "__VITE_ASSET__CPOBGUyA__"